import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { isIAS, isMaps } from '../../../modules/checkDeployEnv';

import TelemetryConfigurationContainer from '../../containers/TelemetryConfigurationContainer';
import TelemetryContainer from '../../containers/TelemetryContainer';
import TestTelemetryConnection from '../TestTelemetryConnection';
import PageHeader from '../../atoms/PageHeader';

const UserConfiguration = ({ deployEnv }) => (
  <Row>
    <Col xs={12} sm={8}>
      <PageHeader>
        <h4>User Configuration</h4>
      </PageHeader>
      <h5>{isMaps(deployEnv) ? 'Server Connection' : 'Telemetry'} Configuration</h5>
      <TelemetryConfigurationContainer deployEnv={deployEnv} />
      {isIAS(deployEnv) && (
        <TelemetryContainer component={state => <TestTelemetryConnection {...state} />} />
      )}
    </Col>
  </Row>
);

UserConfiguration.propTypes = {
  deployEnv: PropTypes.string.isRequired
};

export default UserConfiguration;
